import React, { useState } from 'react'
import getImageUrl from '../functions/getImageUrl';
import BackgroundElementPoster from './BackgroundElementPoster';


const BackgroundVideoElementPoster = ({
    poster,
    isMobile,
}) => {
    const posterSettings = poster ? getImageUrl(poster, isMobile, true, false) : null
    let cssClassesPoster = 'background-visuals-poster theme-radius-posters-full';
    const [fallbackInUse, setFallback] = useState(false)


    return <BackgroundElementPoster
        poster={poster}
        cssClassesPoster={cssClassesPoster}
        posterSettings={posterSettings}
        fallbackInUse={fallbackInUse}
        setFallback={setFallback}
    />

}

export default BackgroundVideoElementPoster